import React from 'react';
import { Grid, Card, CardContent, Typography, Link, Button } from '@material-ui/core';
import { useEntity } from '@backstage/plugin-catalog-react';
import { InfoCard } from '@backstage/core-components';
import Alert from '@material-ui/lab/Alert';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

export const EntityAnsibleContent = () => {
  const { entity } = useEntity();
  const ansibleOrg = entity.metadata.annotations?.['nestle.com/ansible-organization'];

  // AAP instance URL - hardcoded for now
  // TODO: Make this configurable via app-config when we add backend proxy
  const aapBaseUrl = 'https://aap-nprd-aap.apps.ta7u8vz4.westeurope.aroapp.io';

  return (
    <Grid container spacing={3}>
      {/* Info Banner */}
      <Grid item xs={12}>
        <Alert severity="info">
          <Typography variant="body2">
            <strong>Note:</strong> Live data fetching from AAP requires a backend API endpoint.
            For now, use the quick links below to view jobs and templates directly in AAP.
          </Typography>
        </Alert>
      </Grid>

      {/* AAP Connection Info */}
      <Grid item xs={12}>
        <InfoCard title="Ansible Automation Platform">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body1" gutterBottom>
                <strong>AAP Instance:</strong>{' '}
                <Link href={aapBaseUrl} target="_blank" rel="noopener noreferrer">
                  {aapBaseUrl}
                  <OpenInNewIcon style={{ fontSize: 16, marginLeft: 4, verticalAlign: 'middle' }} />
                </Link>
              </Typography>
            </Grid>
            {ansibleOrg && (
              <Grid item xs={12}>
                <Typography variant="body1">
                  <strong>Organization:</strong> {ansibleOrg}
                </Typography>
              </Grid>
            )}
            <Grid item xs={12}>
              <Typography variant="body1">
                <strong>Entity:</strong> {entity.metadata.name}
              </Typography>
            </Grid>
          </Grid>
        </InfoCard>
      </Grid>

      {/* Quick Access Cards */}
      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Jobs
            </Typography>
            <Typography variant="body2" color="textSecondary" paragraph>
              View and monitor Ansible job executions
            </Typography>
            <Button
              variant="contained"
              color="primary"
              href={`${aapBaseUrl}/#/jobs`}
              target="_blank"
              rel="noopener noreferrer"
              endIcon={<OpenInNewIcon />}
            >
              View All Jobs
            </Button>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Templates
            </Typography>
            <Typography variant="body2" color="textSecondary" paragraph>
              Browse and launch job templates
            </Typography>
            <Button
              variant="contained"
              color="primary"
              href={`${aapBaseUrl}/#/templates`}
              target="_blank"
              rel="noopener noreferrer"
              endIcon={<OpenInNewIcon />}
            >
              View All Templates
            </Button>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Projects
            </Typography>
            <Typography variant="body2" color="textSecondary" paragraph>
              Manage Ansible projects and playbooks
            </Typography>
            <Button
              variant="contained"
              color="primary"
              href={`${aapBaseUrl}/#/projects`}
              target="_blank"
              rel="noopener noreferrer"
              endIcon={<OpenInNewIcon />}
            >
              View All Projects
            </Button>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Inventories
            </Typography>
            <Typography variant="body2" color="textSecondary" paragraph>
              Browse host inventories and groups
            </Typography>
            <Button
              variant="contained"
              color="primary"
              href={`${aapBaseUrl}/#/inventories`}
              target="_blank"
              rel="noopener noreferrer"
              endIcon={<OpenInNewIcon />}
            >
              View All Inventories
            </Button>
          </CardContent>
        </Card>
      </Grid>

      {/* Backstage Integration */}
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Create Ansible Workflows
            </Typography>
            <Typography variant="body2" color="textSecondary" paragraph>
              Use Backstage templates to create and launch Ansible jobs
            </Typography>
            <Button
              variant="outlined"
              color="primary"
              href="/create?filters[tags]=ansible"
            >
              Browse Ansible Templates
            </Button>
          </CardContent>
        </Card>
      </Grid>

      {/* Documentation */}
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Resources
            </Typography>
            <Grid container spacing={2}>
              <Grid item>
                <Link
                  href="https://docs.ansible.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ansible Documentation
                </Link>
              </Grid>
              <Grid item>
                <Link
                  href={`${aapBaseUrl}/#/documentation`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  AAP Documentation
                </Link>
              </Grid>
              <Grid item>
                <Link
                  href="/ansible"
                  rel="noopener noreferrer"
                >
                  Ansible Portal
                </Link>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};
